<template>
    <el-dialog :title="title" :visible="showflag" :width="width" @close="closeDialog">
        <el-form ref="formValidate" :model="model" label-width="120px">
            <el-form-item label="TOKEN：" prop="token">
                <span>{{model.token}}</span>
            </el-form-item>
            <el-form-item label="系统时间：" prop="system_time">
                <span>{{model.sys_time}}</span>
            </el-form-item>
            <el-form-item label="服务时间：" prop="service_time">
                <span>{{model.ser_time}}</span>
            </el-form-item>
            <el-form-item label="当前时间：" prop="current_time">
                <span>{{model.cur_time}}</span>
            </el-form-item>
            <el-form-item label="版本：" prop="version">
                <span>{{model.version}}</span>
            </el-form-item>
            <el-form-item label="温度：" prop="temp">
                <span>{{model.temp}}</span>
            </el-form-item>
            <el-form-item label="状态：" prop="state">
                <span>{{model.state}}</span>
            </el-form-item>
            <el-form-item label="CPU百分比：" prop="cpu">
                <span>{{model.cpu}}</span>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
    </el-dialog>
</template>

<script>
import editutil from '@/libs/editutil'
import { saveModel } from '@/api/common'

export default {
    name: 'mdhzLogInfo',
    mixins: [editutil],
    data() {
        return {
            model: {
                token: '',
                system_time: '',
                service_time: '',
                current_time: '',
                temp: '',
                state: '',
                cpu: '',
            },
            getObj:{
                url:'/api/admin/mdhzlog/info',
                data:{
                    key:'id',
                    value:''
                }
            },
            enu_name: [],
        };
    },
    methods: {}
};
</script>